import React from 'react';
import { Link } from 'react-router-dom';

function capitalizarProducto(producto) {
  return producto
    .replace(/-/g, " ") // Reemplaza guiones por espacios
    .split(" ") // Divide el texto en palabras
    .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1)) // Capitaliza la primera letra
    .join(" "); // Une las palabras nuevamente
}

const TituloGracias = ({ producto }) => {
  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="pt-4 pt-lg-4 pt-xl-4">
              <div className="title-style4 mb-1-9 z-index-9 position-relative">
                {/* Mostrar el producto con formato */}
                {producto && (
                <h2 className="wow fadeInUp" data-wow-delay="200ms">
                  <span className="text-primary">
                  En breve, nuestro equipo se pondrá en contacto contigo para brindarte más información sobre nuestros productos <strong ong>{capitalizarProducto(producto)}</strong>
                  </span><br></br><br></br>
                  <span>¡Gracias por contactarnos!</span>
                </h2>
                 )}
              </div>
              <Link to="/" className="butn-style6 white text-primary-hover">
                Ver más productos de nosotros
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TituloGracias;
